module.exports = __webpack_public_path__ + "static/media/vegitables_19.d9b57ca0.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_19.csv
// module id = 601
// module chunks = 0